import { ChangeDetectionStrategy, Component } from '@angular/core';
import { sleep } from '@cf-shared/shared-util';
import { lockClick } from 'directives/cs-capture-cover/cs-capture-cover.directive';
import { NavController } from 'providers/nav-controller';

// The Double-Click Prevention Test card's body on the Test UI Components page: a button that pops
// the page after 1 s, so a fast second tap shows whether lockClick lets only one pop through.
@Component({
  selector: 'cs-test-double-click-card',
  host: { class: 'showcase-card-body' },
  template: `
    <cs-item-list>
      <cs-item>
        <cs-label>Tap below twice fast. Only one pop should happen (1s delay):</cs-label>
      </cs-item>
      <cs-item>
        <cs-button item-right (click)="handleDoubleClickTest($event)" [label]="'Pop Page' | untranslated"
          data-test="double-click-test" fit-width>
        </cs-button>
      </cs-item>
    </cs-item-list>
  `,
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsTestDoubleClickCardComponent {
  constructor(private navCtrl: NavController) {}

  // locks the button until the delayed pop has finished
  handleDoubleClickTest(event: Event) {
    console.log('[double-click-test] handler fired');
    lockClick(event, this.handleDoubleClickTestAsync());
  }

  private async handleDoubleClickTestAsync() {
    await sleep(1000);
    await this.navCtrl.popAsync();
  }
}
